(function () {
  if (window.mwcTopbarInitialized) return;
  window.mwcTopbarInitialized = true;

  async function setUser() {
    const nameEl = document.getElementById("mwc-user-name");
    if (!nameEl) return;

    try {
      const data = await MWC.me();

      if (!data || !data.logged_in) {
        nameEl.textContent = "Guest";
        return;
      }

      nameEl.textContent = "Account";
    } catch (e) {
      nameEl.textContent = "Guest";
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    setUser();

    const logoutBtn = document.getElementById("mwc-logout");

    if (logoutBtn) {
      logoutBtn.addEventListener("click", function (e) {
        e.preventDefault();

window.location.href =
  (
    window.mwcConfig && window.mwcConfig.environment === "development"
      ? "https://dev-edge."
      : "https://edge."
  ) +
  window.location.host +
  "/logout?redirect=" +
  encodeURIComponent(window.location.origin + "/pages/mwc");
      });
    }
  });
})();